import {
  CALENDAR_VIEW_FROM_SLUG,
  isMetricsSectionSlug,
  isMetricsSubTabSlug,
  PATIENTS_STATUS_FROM_SLUG,
  PROFILE_TAB_FROM_SLUG,
  PWA_PROFILE_TAB_FROM_SLUG,
} from '../routes/slugs';

/**
 * Rutas que existen en la app mobile (ver `PwaApp`). Sirve para decidir qué hacer con un link interno que llega
 * desde una notificación o un aviso: si la app mobile no tiene esa pantalla, se abre la plataforma web.
 * Mantener alineado con las `<Route>` de `PwaApp`.
 *
 * `/calendar` es la Agenda de la app y `/calendar/<vista>` un alias (`/calendar?view=`); `/calendar/time-off` NO (es otra pantalla).
 * `/home` existe, pero solo la ven quienes tienen acceso a Home: el resto vuelve a la Agenda (lo decide `PwaShell`).
 */
const EXACT = new Set(['/', '/home', '/notificaciones', '/comunidad', '/comunidad/newsletter', '/calendar', '/patients', '/patients/derivation', '/profile', '/profile/farewell']);

const has = (map: Record<string, unknown>, key: string) => Object.prototype.hasOwnProperty.call(map, key);

export function isRouteInPwaApp(url: string): boolean {
  let pathname: string;
  try {
    pathname = new URL(url, 'https://x.invalid').pathname.replace(/\/+$/, '') || '/';
  } catch {
    return false;
  }
  if (EXACT.has(pathname) || /^\/comunidad\/novedades\/[^/]+$/.test(pathname)) return true;
  const calendarView = /^\/calendar\/([^/]+)$/.exec(pathname)?.[1];
  if (calendarView) return has(CALENDAR_VIEW_FROM_SLUG, calendarView);
  const patientsStatus = /^\/patients\/([^/]+)$/.exec(pathname)?.[1];
  if (patientsStatus) return has(PATIENTS_STATUS_FROM_SLUG, patientsStatus);
  const profileTab = /^\/profile\/([^/]+)$/.exec(pathname)?.[1];
  if (profileTab) return has(PROFILE_TAB_FROM_SLUG, profileTab) || has(PWA_PROFILE_TAB_FROM_SLUG, profileTab);
  // /profile/metricas/<subtab>[/<seccion|panel>]
  const metrics = /^\/profile\/metricas\/([^/]+)(?:\/([^/]+))?$/.exec(pathname);
  if (metrics) {
    const [, subtab, section] = metrics;
    return isMetricsSubTabSlug(subtab) && (!section || isMetricsSectionSlug(subtab, section));
  }
  return false;
}
